import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { HeaderMenuConfig, MDS_HEADER_MENU_CONFIG } from '@mds/ngx-auth';

export function provideHeaderConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MDS_HEADER_MENU_CONFIG,
      useValue: {
        showLanguageSwitch: true,
        showThemeSwitch: false,
        showBranchSwitch: true,
        additionalItems: [],
      } satisfies HeaderMenuConfig,
    },
  ]);
}
